<template>
  <div class="ibox form-page animated fadeInRightBig">
    <div class="ibox-title form-page__header">
      <div class="form-page__title-wrap">
        <h5 class="form-page__title">Envio avulso</h5>
        <p class="form-page__subtitle">Anexe documentos e selecione os destinatários</p>
      </div>
    </div>
    <div class="ibox-content form-page__body">
    <div class="row">
      <div class="col-12">
        <div class="form-group form-page__field">
          <label class="form-page__label">Nome do documento</label>
          <input type="text" class="form-control" v-model="detatched.name" placeholder="Nome do documento" />
        </div>
      </div>
    </div>
    <input id="fileInputed" type="file" hidden @change="fileInputed()" />
    <div class="ml-1 row mt-3 card-columns">
      <div class="card col-2" v-for="(file, index) in files" :key="index">
        <div class="centered">
          <i class="centered p-4 fa fa-4x fa-file-pdf red"></i>
        </div>
        <div class="card-body">
          <h5 class="card-title">
            {{ file.name }}
          </h5>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <input type="checkbox" checked="file.sign" v-model="file.sign" />
            <b>Necessário assinar</b>
          </li>
          <li class="list-group-item"><b>Tamanho:</b> {{ file.file.size / 1000 }} kB</li>
        </ul>
        <div class="card-body text-right">
          <button class="btn btn-danger" @click="remove(index)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
      <div class="card add-one col-2 centered clickable" @click="addClicked()">
        <h5 class="card-title mt-5">Adicionar documento</h5>
        <i class="centered p-4 fa fa-4x fa-plus green"></i>
      </div>
    </div>
    <hr>
    <br>
    <h5 class="card-subtitle">Seleção dos destinatários</h5>
    <br>
    <users-selection
      ref="usersSelection"
      :selectedUsersTotal="selectedUsersTotal"
      @selectedUsersTotalChanged="selectedUsersTotalChanged"
    ></users-selection>
    <div class="form-page__footer">
      <div class="form-page__actions">
        <router-link :to="'/detatcheds'" class="btn btn-return">
          <i class="fa fa-arrow-left"></i> Voltar
        </router-link>
        <button class="btn btn-add" @click="save">
          <i class="fa fa-save"></i> Salvar
        </button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import UsersSelection from "../Utils/UsersSelection";
import VSelectDefault from "../Utils/VSelectDefault";
export default {
  data() {
    return {
      selectedUsersTotal: [],
      detatched: {
        name: ''
      },
      files: [],
    };
  },
  methods: {
    remove(index) {
      this.files.splice(index, 1);
    },
    addClicked() {
      $("#fileInputed").click();
    },
    save() {
      $("#page_loader").show();

      const self = this;
      let api = self.$store.state.api + "signature-api-document";

      const id = this.$route.params.id;
      if (id) {
        api += "/" + id;
      }

      const fd = self.makeFormData();

      if (!fd) {
        $("#page_loader").hide();
        return;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", "Documento cadastrado com sucesso", "success");
          self.$router.push("/detatcheds");
          $("#page_loader").hide();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    selectedUsersTotalChanged(selectedUsersTotal) {
      this.selectedUsersTotal = selectedUsersTotal;
    },
    makeFormData() {
      const self = this;
      const fd = new FormData();

      self.$refs.usersSelection.selectedUsersTotal.forEach((user, index) => {
        fd.append("processosEmail[" + index + "][cpfFunc]", user.cpf);
        fd.append("processosEmail[" + index + "][idFunc]", user.register);
        fd.append("processosEmail[" + index + "][nomeFunc]", user.name);
        fd.append("processosEmail[" + index + "][email]", user.email);
        fd.append("processosEmail[" + index + "][idProcesso]", 9999);
        fd.append("processosEmail[" + index + "][data]", moment().format('YYYY-MM-DD'));
      })

      fd.append("is_detatched_sending", 1);

      fd.append("controle[idEnvio]", 99999);
      fd.append("controle[tipoProcesso]", self.detatched.name);
      fd.append("controle[dataEnvio]", moment().format('YYYY-MM-DD'));
      fd.append("controle[horaEnvio]", moment().format('HH:mm'));

      self.files.forEach((file, index) => {
        fd.append("arquivos[" + index + "][nome]", file.name);
        fd.append("arquivos[" + index + "][conteudo]", file.base64);
        fd.append("arquivos[" + index + "][assina]", file.sign ? 'x' : '');
        fd.append("arquivos[" + index + "][idProcesso]", 9999);
        fd.append("arquivos[" + index + "][tipo]", self.detatched.name);
        fd.append("arquivos[" + index + "][data]", moment().format('YYYY-MM-DD'));
        fd.append("arquivos[" + index + "][hora]", moment().format('HH:mm'));
      });

      const id = self.$route.params.id;
      if (id) {
        fd.append("id", id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getBase64(file, index) {
      const self = this
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.files[index].base64 = reader.result.split(',')[1];
      };
    },
    fileInputed() {
      const file = document.getElementById("fileInputed").files[0];
      if (file) {
        const name = this.getFileName(document.getElementById("fileInputed").value);
        const nameSplitted = name.split('.')
        if(nameSplitted[nameSplitted.length - 1] !== 'pdf'){
          this.$message("Erro", 'O arquivo precisa ser do tipo PDF', "error");
          return
        }
        this.files.push({
          name: name,
          file: file,
          base64: this.getBase64(file, this.files.length),
          sign: false,
        });
      }
      document.getElementById("fileInputed").value = "";
    },
    getFileName(fullPath) {
      var startIndex =
        fullPath.indexOf("\\") >= 0
          ? fullPath.lastIndexOf("\\")
          : fullPath.lastIndexOf("/");
      var filename = fullPath.substring(startIndex);
      if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
        filename = filename.substring(1);
      }
      return filename;
    },
  },

  mounted() {},
  components: {
    VSelectDefault,
    UsersSelection
  },
};
</script>

<style scoped>
.card {
  width: 200px;
  min-height: 250px;
}
.add-one {
  border: 3px dashed gray;
  background: #e6e6e6;
  border-radius: 0.5rem;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Detatched/Detatched.vue